import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useUIStore, type Language } from '@/stores/uiStore';

const labels: Record<Language, string> = {
  'uz-Latn': 'O‘z',
  'uz-Cyrl': 'Ўз',
  ru: 'Ру',
  en: 'En',
};

export function LanguageMenu() {
  const { i18n } = useTranslation();
  const language = useUIStore((s) => s.language);
  const setLanguage = useUIStore((s) => s.setLanguage);

  const handleChange = (value: string) => {
    const lang = value as Language;
    setLanguage(lang);
    void i18n.changeLanguage(lang);
  };

  return (
    <Select value={language} onValueChange={handleChange}>
      <SelectTrigger className="h-9 w-auto min-w-[5.5rem] gap-2 rounded-full border-border/60 bg-card/70 px-3 text-xs font-semibold uppercase tracking-[0.18em]">
        <Globe className="h-3.5 w-3.5" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {(Object.keys(labels) as Language[]).map((code) => (
          <SelectItem key={code} value={code}>
            {labels[code]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
